import { useBFF } from '~/composables/useBFF/useBFF';

export default defineNuxtPlugin(async (nuxtApp) => {
  const { $deliveryTime } = useBFF();

  const times = useState<DeliveryTime>(`deliveryTimes-${useRequestURL().hostname}`, () => ({ }));

  if (!Object.keys(times.value).length) {
    try {
      const { data } = await $deliveryTime.getDeliveryTime();

      times.value = data as DeliveryTime;
    }
    catch {
      times.value = {};
    }
  }

  const deliveryTime = {
    ...times.value,
  };

  nuxtApp.provide('times', deliveryTime);
});
